import { loadAccount } from '~/utils/AccountLoader';
import { loadNavItemsWithSidebar } from '~/utils/NavItemsLoader';
import type { RouteLocationNormalized } from 'vue-router';

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized) => {
    await loadAccount();
    await loadNavItemsWithSidebar(to);
});
